import React from "react";
import { RuleGraphCtx, type RuleGraphProviderCtx } from "../providers/RuleGraphProvider";

/**
 *
 * @param outOfContextDefaults - it won't be often this will be used, but very occasionally, you might need to use a \
 * component that uses this hook, where a static default would be absolutely fine.
 * @returns
 */
export const useGraphVisualisation = (outOfContextDefaults?: any) => {
  try {
    const ruleGraphCtx = React.useContext<RuleGraphProviderCtx>(RuleGraphCtx);

    const countEntityColors = 8;
    const entityColorMapping = ruleGraphCtx.entities.map((entity, idx) => ({
      entity,
      colorKey: `--value-color-entity-${idx % countEntityColors}`,
    }));

    const showFocusAndExpandControls = ["classic", "classic-beta"].includes(ruleGraphCtx.graphVizType);

    return {
      graphVizType: ruleGraphCtx.graphVizType,
      extraVizTypes: ruleGraphCtx.extraVizTypes,
      setGraphVizType: ruleGraphCtx.setGraphVizType,
      graph: ruleGraphCtx.graph,
      visible: ruleGraphCtx.visible,
      selectedNode: ruleGraphCtx.selectedNode,
      selectedNodeId: ruleGraphCtx.selectedNodeId,
      selectedNodeValue: ruleGraphCtx.selectedNode?.value ?? null,
      setSelectedNodeId: ruleGraphCtx.setSelectedNodeId,
      rstSelectedNode: () => ruleGraphCtx.setSelectedNodeId(null),
      defaultView: ruleGraphCtx.defaultView,
      hasClassic: ruleGraphCtx.hasClassic,
      hasNebula: ruleGraphCtx.hasNebula,
      hasData: ruleGraphCtx.hasData,
      release: ruleGraphCtx.release || ruleGraphCtx.fullRelease,
      debug: ruleGraphCtx.debug,
      hasDecisionReport: ruleGraphCtx.hasDecisionReport,
      hasFocus: ruleGraphCtx.hasFocus,
      report: ruleGraphCtx.report,
      switchView: ruleGraphCtx.switchView,
      goal: ruleGraphCtx.goal,
      colorScheme: ruleGraphCtx.colorScheme,
      setColorScheme: ruleGraphCtx.setColorScheme,
      entities: ruleGraphCtx.entities,
      entityColorMapping,
      temporalSlice: ruleGraphCtx.temporalSlice,
      setTemporalSlice: ruleGraphCtx.setTemporalSlice,

      showFocusAndExpandControls,
      restrictedView: ruleGraphCtx.restrictedView,
      rstRestrictedView: ruleGraphCtx.rstRestrictedView,
      restrictViewToDepth: ruleGraphCtx.restrictViewToDepth,
      setRestrictedViewRootPath: ruleGraphCtx.setRestrictedViewRootPath,
      setVisibleNodes: ruleGraphCtx.setVisibleNodes,
      rstVisibleNodes: ruleGraphCtx.rstVisibleNodes,
      addVisibleNodes: ruleGraphCtx.addVisibleNodes,
      // isGraphViewRestricted: !!(ruleGraphCtx.restrictedView?.rootPath && (ruleGraphCtx.restrictedView?.graphDepth ?? null) !== null),
      setRestrictedViewNodesToMerge: ruleGraphCtx.setRestrictedViewNodesToMerge,
      nodeRenderLimit: ruleGraphCtx.nodeRenderLimit,
      setNodeRenderLimit: ruleGraphCtx.setNodeRenderLimit,
    };
  } catch (e) {
    console.error(
      "Error in useGraphVisualisation - likely trying to use this out of context. Defaults will be returned",
      e,
    );
    return outOfContextDefaults || {};
  }
};

/**
 * This calculates the maximum from a chosen root node to any other node in the graph.
 * Move to the bottom here for the time being, because we're not using it...
 */
// const maxDepthFromRestrictedViewRootPath = React.useMemo(() => {

//   let maxDepthFromFocus: number | null = null;
//   const restrictedViewRootPath = ruleGraphCtx.restrictedView?.rootPath;
//   const graph = ruleGraphCtx.graph;
//   const isShowHidden = !(ruleGraphCtx.debug);

//   if (restrictedViewRootPath && graph) {
//     let graphToWalk = graph;
//     if (!(graphToWalk._nodes)) {
//       // we need to get the graph into `MutableGraph<{}>` format
//       graphToWalk = graphFromJSON(graph);
//     }
//     if (graphToWalk.node(restrictedViewRootPath)) {
//       const dj = graphDistances(
//         graphToWalk,
//         restrictedViewRootPath,
//         undefined,
//         (v) => graphToWalk.nodeEdges(v), // if you wanted to find all paths use this
//       );
//       let maxDepthFromFocusInner = 0;
//       // console.log("dj", dj);
//       // console.log("test node", graphToWalk.node("0adcf633-d964-492d-9a7e-d6dbc62b4b73"));
//       // console.log("isShowHidden", isShowHidden);
//       Object.keys(dj).forEach((w) => {
//         if (dj[w].distance !== Infinity) {
//           // Infinite distance means these nodes aren't connected to the root
//           const reachableNode = graphToWalk.node(w);
//           const isHidden = reachableNode.hidden ?? false;
//           const isGlobal = reachableNode?.entity === "global";
//           if ((!isHidden || isShowHidden)) {
//             maxDepthFromFocusInner = Math.max(maxDepthFromFocusInner, dj[w].distance);
//             // console.log("used node", dj[w]);
//             // console.log("which is this node", graphToWalk.node(w))
//           }
//         }
//       });
//       maxDepthFromFocus = maxDepthFromFocusInner;
//     }
//   }

//   // check if restrictedViewDepth exceeds maxDepthFromFocus
//   const restrictedViewDepth = ruleGraphCtx.restrictedView?.graphDepth ?? null;
//   if (restrictedViewDepth !== null && maxDepthFromFocus !== null && (restrictedViewDepth > maxDepthFromFocus)) {
//     ruleGraphCtx.restrictViewToDepth(maxDepthFromFocus);
//   } else if (maxDepthFromFocus === null && restrictedViewDepth !== null) {
//     ruleGraphCtx.restrictViewToDepth(null);
//   } else if (restrictedViewDepth === null && maxDepthFromFocus !== null) {
//     if (maxDepthFromFocus > 0) {
//       // just default it to 1 so the user can walk outwards
//       ruleGraphCtx.restrictViewToDepth(1);
//     } else if (maxDepthFromFocus === 0) {
//       // they've selected something with no connections...
//       // this is a special case, but we need to set the depth to something other than null
//       ruleGraphCtx.restrictViewToDepth(0);
//     }
//   }

//   return (maxDepthFromFocus);
// }, [ruleGraphCtx.graph, ruleGraphCtx.restrictedView?.rootPath]);
